var magicStyles = [".text[data-v-3206129f]{margin:0 0 var(--magic-space,16px);min-height:100px;text-align:center}.resend-section[data-v-3206129f]{text-align:center}.resend-section .cooldown-text[data-v-3206129f]{display:block;color:var(--magic-text-light)}"];

export default magicStyles;
